import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup,AbstractControl } from '@angular/forms';     
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { formatDate } from '@angular/common';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { element } from '@angular/core/src/render3/instructions';
import { Router, ActivatedRoute } from '@angular/router';
import { MustMatch } from '../../../../_helpers/must-match-validator'


const today = new Date();
var time_today = today.getTime();
var refid = "CID_" + time_today;
const entityId = "EID_" + time_today;


let now = new Date();
const currentdat = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');   

export interface Type {
  value: string;
  viewValue: string;
}
export interface oType {
  value: string;
  viewValue: string;
}
export interface oCat {
  value: string;
  viewValue: string;
}
export interface Role {
  value: string;
  viewValue: string;
}
export interface Id {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-entity-registration',
  templateUrl: './entity-registration.component.html',
  styleUrls: ['./entity-registration.component.css']
})
export class EntityRegistrationComponent implements OnInit {
  redid = refid;
  showPeTmRemainingFeilds: boolean=false;
  roleSelected: any;
  disableForm: boolean=false;
  fileSizeError1: boolean=false;
  fileSizeError2: boolean=false;
  constructor(private fb: FormBuilder,
    private es: APILoginService,
    private ls: APIEntityService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    private router: Router) { 
      this._route.params.subscribe((params) => {
        this.selectedValue = params['role'];
     
     

      })
    }



  // For Principal Entity
  entityForm: FormGroup;
  pePrefix: string = "";
  Entity_Addr_DLT: string = ""
  identifiedVal: string = "";
  rootVal: string = "";
  public entityValidatedFlag = true;
  public Entity_ID_Existing = 'N';
  public IsChild_Org = 'N';
  public E_Create_Date;
  hide = true;
  tataRole: any;
  // For Tata Employee
  Entity_EMP_ID: string = "";
  /*  onChangeRootVal() {
      this.rootVal = this.pePrefix + this.identifiedVal;  

    } */

  /*  File Upload */
  uploadKYC: string[];
  //uploadAgreement: string[];
  uploadCAF: string[];

  // For Entity ID pattern
  eidPatternString: string = '';
  eidPattern: string = "";

  // For Entity Role
  roles: Role[] = [
    { value: 'Network Adminstrator', viewValue: 'Network Adminstrator' },
    { value: 'Application Adminstrator', viewValue: 'Application Adminstrator' },
    { value: 'Operations User', viewValue: 'Operations User' }
  ];
  selectedValue: String;
  selectedValueCat: String;
  selectedValue1: String;
  selectedValue2: String;
  alreadyEntity;
  types: Type[] = [
    { value: 'Tata Employee', viewValue: 'Tata Employee' },
    { value: 'TM', viewValue: 'TeleMarketer' },
    { value: 'PE', viewValue: 'Principal Entity' }
  ];
  otypes: oType[] = [
    { value: 'Cooperative', viewValue: 'Cooperative' },
    { value: 'Sole Propriertorship', viewValue: 'Sole Propriertorship' },
    { value: 'Family Owned Business', viewValue: 'Family Owned Business' },
    { value: 'Private Limited Company', viewValue: 'Private Limited Company' },
    { value: 'Public Limited Company', viewValue: 'Public Limited Company' },
    { value: 'Educational Institution', viewValue: 'Educational Institution' },
    { value: 'Political Party', viewValue: 'Political Party' },
    { value: 'NGO', viewValue: 'NGO' },
    { value: 'Nationalised Bank', viewValue: 'Nationalised Bank' },
    { value: 'Private Bank', viewValue: 'Private Bank' },
    { value: 'Life Insurance Company', viewValue: 'Life Insurance Company' },
    { value: 'General Insurance Company', viewValue: 'General Insurance Company' },
    { value: 'SEBI Registered Broker', viewValue: 'SEBI Registered Broker (Please Upload SEBI Certificate)' },
    { value: 'Others', viewValue: 'Others' }
  ];

  ocats: oCat[] = [
    { value: 'G', viewValue: 'Government' },
    { value: 'P', viewValue: 'Private' },
	{ value: 'S', viewValue: 'SEBI' },
    { value: 'U', viewValue: 'Public Limited Company' },
	{ value: 'O', viewValue: 'Others' }
  ];


  ids: Id[] = [
    { value: '1', viewValue: 'Branch' },
    { value: '2', viewValue: 'Region' },
    { value: '3', viewValue: 'Department' }
  ];


  communicationPerf: any;
  public categoryres: any;
  selectedCategory: string;
  public myModelProperty: Array<any>;
  public EntityType: any;
  public EntityRole: any;
  public PEIdentity: any;
  public data: any;
  public entityIdcheck: any;
  public Entity_ID = '';
  public Child_OrgName: any;
  // For Existing Entity Id
  entCheck;
  submitted: boolean = false;
  checkEvent;
  warningForNotMatchingEnitity: boolean = false;
  PancardChecking: boolean = false;
  makeRead: boolean = false;
  public EntityName;
  public EOrg_Type;
  public EOrg_Name;
  public EPoi;
  public entityPresentFlag: boolean = true;
  public existEntityFlag: boolean = false;
  photoName: any;
  photoContent: any;
  fileExtension: any;
  panAlreadyHave;
  fileExtensionError: boolean = false;
  fileExtensionMessage: any;
  get f() { return this.entityForm.controls; }
 
 myfiles:any []=[];      
 
  ngOnInit() {
		this.router.navigateByUrl('/tmpe-common-registration-01')

   
    this.entityForm = this.fb.group({ 
      Entity_Type: ['',],
      Entity_Class: ['',],
      Pancard: ['',],
      PancardAlready: [''],       
      child_OrgName: ['',],
      Organization_Type: ['',],
      Organization_Cat: ['',],
      Organization: ['', [Validators.required,noWhiteSpace,Validators.minLength(5), Validators.maxLength(30), Validators.pattern(/^([A-Za-z0-9._]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,3})*$/)]],   
      Entity_Role: ['',],
      existEntity_ID: ['',],    
      child_Org: ['',],  
      Entity_ID: ['',], 
      Entity_EMP_ID: ['', [Validators.required,Validators.minLength(5),Validators.maxLength(15),Validators.pattern(/^[a-zA-Z0-9]*$/)]],
     // Entity_Name: new FormControl('',validators.compose([Validators.required,Validators.pattern('^[a-zA-Z]+$')])),      
     Entity_Name: ['', [Validators.required,noWhiteSpace]],     

      // Entity_User_Name: ['', Validators.required], 
      Entity_Mobile_No: ['', [Validators.required, Validators.pattern("[1-9][0-9]{9}")]],
   //   Entity_Password: ['', Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})"],   
   //email: ['', [Validators.required, Validators.pattern(/^([A-Za-z0-9._]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,3})*$/)]],
   email: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,10}$')]],


//email: ['', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      Entity_Password: ['', Validators.pattern(/^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/)], 
// email: ['', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      Entity_Addr: ['',noWhiteSpace],
      uploadKYC1: ['',],
      kycDocNo:['',noWhiteSpace],
    //  emailOfficial:[],    
      // uploadAgreement: ['',], 
      //PE_Prefix: ['',],  
      //PE_Identity: ['',],
      //code: ['',],
      //rootHeader: ['',],
      poiType: ['',],
      Entity_ID_Existing: ['',], IsChild_Org: ['',],  
      confirmPassword: ['', Validators.required]
    }, {
        validator: MustMatch('Entity_Password', 'confirmPassword')
      });

      this.onChangePattern(this.selectedValue)
  }

  valuechange(checkEntityId,checkPan) {
    //console.log("chk ", searchValue, this.EntityType);
    console.log("I am here to check the already have entity id and pan")
    let data = {
      "Entity_ID": checkEntityId,
     "POI":checkPan,
      "Entity_Class": this.selectedValue
    }
    console.log("data :", data);
    this.entityForm.controls['Pancard'].setValue(null);
    //this.entityForm.controls['Entity_Name'].setValue(null);
    this.entityForm.controls['Organization_Type'].setValue(null);
    this.entityForm.controls['Organization'].setValue(null);

    this.ls.fetchEntityDetails(data)
      .subscribe(r => {
        console.log("responsw frm fetching entityid :", r, r.data.Entity_Addr_DLT);
		this.Entity_Addr_DLT = r.data.Entity_Addr_DLT
        this.entityPresentFlag = true;
        if (r.message == "Entity ID not present") {
          this.entityPresentFlag = false;
          this.$modal.errorModal({
            title: 'Registration',
            msg: 'Entity ID not present'
          });
        }
        else if (r.message == "Entity ID already exists") {
          this.entityPresentFlag = false;
          this.$modal.errorModal({
            title: 'Registration',
            msg: 'This PE/TM ID is already registered with Tata Teleservices. You can login to the DLT portal using your credentials (Email ID & Password)'
          });
        }
        else if (r.message == "Entity is already registered and pending for approval") {
          this.entityPresentFlag = false;
          this.$modal.errorModal({
            title: 'Registration',
            msg: 'Entity is already registered and pending for approval'
          });
        }
        else if (r.message == "Data Present") {
          this.showPeTmRemainingFeilds=true;
          this.entityPresentFlag = true;
        }
        try {

          if (r.message === 'Data Present') {
            //this.entityPresentFlag = true;
            console.log("entity nameeeeeeeeeeeeeeeeeeeee")
            this.PancardChecking = true;
            this.existEntityFlag = true;
            this.EntityName = r.data.Entity_Name;
            this.EOrg_Type = r.data.E_Org_Type;
            this.EOrg_Name = r.data.E_Org_Name;
            this.EPoi = r.POI;
            this.entityForm.controls['Pancard'].setValue(r.data.POI);
            // if(r.data.E_Org_Type=='G') {
            //   this.entityForm.controls['Pancard'].setValue(" ");
            // }

            this.entityForm.controls['Pancard'].disable();

           // this.entityForm.controls['Entity_Name'].setValue(r.data.Entity_Name);      
            this.entityForm.controls['Organization_Cat'].setValue(r.data.E_Org_Type);
            this.entityForm.controls['Organization_Cat'].disable();
            this.selectedValueCat=r.data.E_Org_Type;
            this.entityForm.controls['Organization'].setValue(r.data.E_Org_Name);
            this.entityForm.controls['Organization'].disable();

            this.entityForm.controls['Organization_Type'].setValue("");
            if(r.data.E_Org_Type=='G') {
              console.log("heeeeeeeeeeeeeeeeerrrrrrrrrrrrrrrrrrrrrrrrrrrreeeeeeeeeeeeeeeeeeeeeeee")
              this.entityForm.controls['Organization_Type'].disable(); 
              this.entityForm.controls['Organization_Type'].setValidators(Validators.nullValidator);
               this.entityForm.controls['Organization_Type'].updateValueAndValidity();
            }

            this.makeRead = true;
          }

        }
        catch (e) {
          this.warningForNotMatchingEnitity = true;      
        }

      })
  }
//poiType    

/*kycdoctype()     
{
alert("hi");    
let kyctype=this.poiType.value;  
alert(kyctype);
} */    
   
  onChangePattern(selected) {
	
	  this.entityForm.controls['Organization_Cat'].reset();
	  this.entityForm.controls['poiType'].reset(); 
	  this.entityForm.controls['existEntity_ID'].reset();
    console.log("id entity type ...", selected);
    this.EntityType = selected;
    var changedControls = ["Entity_Role","Entity_ID", "uploadKYC1", "Pancard", "Entity_Name", "Organization_Type", "Organization", "poiType","PancardAlready","Entity_Addr","kycDocNo","Organization_Cat","Entity_EMP_ID"];

    switch (selected) {
      case "Tata Employee":
        for (let i = 0; i < changedControls.length; i++) {
          if (changedControls[i] === changedControls[0] || changedControls[i] === changedControls[12] ) {
            this.entityForm.controls[changedControls[i]].enable(); 
            this.entityForm.controls[changedControls[i]].setValidators([Validators.required]);

          }
          else {
            this.entityForm.controls[changedControls[i]].disable();
          }
          this.entityForm.controls[changedControls[i]].updateValueAndValidity();
        }
        break;
      case "TM": 
	  for (let i = 0; i < changedControls.length; i++) {
      if ( changedControls[i] === changedControls[2] || changedControls[i] === changedControls[3] || changedControls[i] === changedControls[4]  
        || changedControls[i] === changedControls[5]  || changedControls[i] === changedControls[6] ||
            changedControls[i] === changedControls[7]  || 
             changedControls[i] === changedControls[9] ||  changedControls[i] === changedControls[10] || changedControls[i] === changedControls[11] ) {
            this.entityForm.controls[changedControls[i]].enable();
            this.entityForm.controls[changedControls[i]].setValidators([Validators.required]);

            console.log("Null validator", this.checkEvent);
           
           if (this.checkEvent=='Yes'){
            console.log("Null validator", this.checkEvent);
           }
            else{
              this.entityForm.controls[changedControls[1]].disable();

            }
          }
          else{
            this.entityForm.controls[changedControls[i]].disable();

          }
          this.entityForm.controls[changedControls[i]].updateValueAndValidity();
          
			 this.entityForm.controls['Pancard'].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)]);
         // this.entityForm.controls['PancardAlready'].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)]);
       //   this.entityForm.controls['PancardAlready'].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)]);
          //  this.entityForm.controls['Pancard'].setValidators([Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/)]);

          this.entityForm.controls[changedControls[i]].updateValueAndValidity();
          
           this.entityForm.controls[changedControls[3]].disable(); //Added
         
         
        }
        break;
      case "PE":
        for (let i = 0; i < changedControls.length; i++) {
          if ( changedControls[i] === changedControls[2] || changedControls[i] === changedControls[3] || changedControls[i] === changedControls[4]  || changedControls[i] === changedControls[5] || changedControls[i] === changedControls[6] ||
             changedControls[i] === changedControls[7]  ||
             changedControls[i] === changedControls[9] ||  changedControls[i] === changedControls[10] || changedControls[i] === changedControls[11]  ) {
            
            this.entityForm.controls[changedControls[i]].enable();
            this.entityForm.controls[changedControls[i]].setValidators([Validators.required]);
            this.entityForm.controls[changedControls[i]].setValidators([Validators.required,]);
            
          //  this.entityForm.controls['Entity_Name'].setValidators([Validators.required,Validators.pattern(/^([a-zA-Z '"]*)$/)]);
            this.entityForm.controls['Pancard'].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)]);

          }
          else {
            this.entityForm.controls[changedControls[i]].disable();
          }
          this.entityForm.controls[changedControls[i]].updateValueAndValidity();
		  
		   this.entityForm.controls[changedControls[3]].disable(); //Added
		   // this.entityForm.controls[changedControls[7]].disable(); //Added 
        }
        break;
      default: break;
    }
    this.entityForm.controls['Entity_ID'].updateValueAndValidity();
  }
  onChangePatternCat(selectedValueCat)
  {
	  console.log("innn -- ",selectedValueCat);
	
    if(this.selectedValueCat === "P" || this.selectedValueCat === "O" || this.selectedValueCat === "U" || this.selectedValueCat === "S"){ 
	
	this.entityForm.controls['poiType'].reset(); 
	
    this.entityForm.controls['Organization_Type'].enable();
    this.entityForm.controls['Organization_Type'].setValidators([Validators.required]);
    this.entityForm.controls['Organization_Type'].updateValueAndValidity();
    console.log("Setting validators for org type")
    
    this.entityForm.controls['Pancard'].enable();
   // this.entityForm.controls['Pancard'].setValidators([Validators.required]);
    this.entityForm.controls['Pancard'].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)]);
    this.entityForm.controls['Pancard'].updateValueAndValidity();
   
   // this.entityForm.controls['poiType'].enable();
    //this.entityForm.controls['poiType'].setValidators([Validators.required]);
   // this.entityForm.controls['poiType'].updateValueAndValidity();
	
	 
   // this.entityForm.controls['Pancard'].setValue(null);
    console.log("Setting validators for Pancard") 
	  
    }
	 else if(this.selectedValueCat === "G"){
		  this.entityForm.controls['poiType'].reset();  
		 console.log("org type G means");
		 this.entityForm.controls['Organization_Type'].disable();
         this.entityForm.controls['Organization_Type'].setValidators(Validators.nullValidator);
          this.entityForm.controls['Organization_Type'].updateValueAndValidity();
          console.log("null vaidations for Organization_Type");

    this.entityForm.controls['Pancard'].enable();
   this.entityForm.controls['Pancard'].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)]);
           this.entityForm.controls['Pancard'].updateValueAndValidity();
		  
	
	
		 // this.entityForm.controls['Pancard'].setValue(null); //Added 
    }
	else{
		 this.entityForm.controls['poiType'].reset();  
		console.log("nothing really");
	}
	//this.entityForm.controls['poiType'].enable();
   // this.entityForm.controls['poiType'].setValidators([Validators.required]);
   // this.entityForm.controls['poiType'].updateValueAndValidity();
	
	 this.entityForm.controls['poiType'].reset();   
    // else if(this.selectedValueCat === "G"){ 
      // this.entityForm.controls['Organization_Type'].setValidators(Validators.nullValidator);
          // this.entityForm.controls['Organization_Type'].disable();
          // console.log("null vaidations for Organization_Type");
          // this.entityForm.controls['Organization_Type'].updateValueAndValidity();

          // this.entityForm.controls['Pancard'].setValidators(Validators.nullValidator);
          // this.entityForm.controls['Pancard'].disable();
          // console.log("null vaidations for Pancard");
        
          // this.entityForm.controls['Pancard'].updateValueAndValidity();
    // }
  }
  onChangeKyc(selection){
	  console.log("selectio---- : ",selection);
  }
  onChangeEntityId(chkEvent, selectedValue) {
//  this.entityForm.reset();

	 this.entityForm.controls['Organization_Cat'].reset();
	 this.entityForm.controls['poiType'].reset(); 
    this.entityForm.controls['Pancard'].setValue(null);
    console.log("inside onChangeEntityId ", chkEvent.value);
    // console.log("chkEvent is :", chkEvent);
    this.checkEvent = chkEvent.value;
    console.log("The value inside check entity",chkEvent.value)
    this.makeRead = false;
    this.entityForm.controls['Pancard'].setValue(null);
   // this.entityForm.controls['Entity_Name'].setValue(null);
    this.entityForm.controls['Organization_Type'].setValue(null);
    this.entityForm.controls['Organization'].setValue(null);
    if(chkEvent.value == 'No'){
      this.existEntityFlag = false;
      this.entityForm.controls['Entity_ID'].setValidators(Validators.nullValidator);
      this.entityForm.controls['Entity_ID'].disable();
      this.entityForm.controls['Entity_ID'].updateValueAndValidity();
      this.entityForm.controls['PancardAlready'].setValidators(Validators.nullValidator);
      this.entityForm.controls['PancardAlready'].disable();
      this.entityForm.controls['PancardAlready'].updateValueAndValidity();
      this.entityForm.controls['Organization_Cat'].reset();
      this.entityForm.controls['Organization_Cat'].enable();


     // this.entityForm.controls['Organization_Cat'].updateValueAndValidity();

      this.entityForm.controls['Organization'].enable();
      this.entityForm.controls['Organization'].updateValueAndValidity();
      console.log("Setting validators for org type")
      console.log("null entity vaidations jhbhjbbjhbjhb");
      this.Entity_ID_Existing = 'N';
    }
    if (chkEvent.value == "Yes") {
      // this.entityForm.controls['Pancard'].setValidators(Validators.nullValidator);
      // this.entityForm.controls['Pancard'].disable();
      // this.entityForm.controls['Pancard'].updateValueAndValidity();
      this.Entity_ID_Existing = 'Y';
      console.log("@row#400")


      // this.entityForm.controls['PancardAlready'].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)]);
      // this.entityForm.controls['PancardAlready'].updateValueAndValidity();

      // this.entityForm.controls['PancardAlready'].reset();
      // this.entityForm.controls['PancardAlready'].enable();
      this.entityForm.controls['Entity_ID'].reset();
      this.entityForm.controls['Entity_ID'].enable();
     
      console.log("Entity_ID_Existing :", this.Entity_ID_Existing, selectedValue);
     

         /* if (selectedValue === "Tata Employee" && chkEvent) { */
      if ((selectedValue === "TM" && chkEvent) || (selectedValue === "PE" && chkEvent)) {

        console.log("1st if true")
        console.log("Entity_ID_Existing :", this.Entity_ID_Existing, selectedValue);
        if (chkEvent) {
          console.log("inside chkEvent")
          this.entityForm.controls['Entity_ID'].reset();
          this.entityForm.controls['Entity_ID'].setValidators([Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/)]);
          console.log("sets validaiiton:", this.eidPattern);

        }
        else {
          console.log("2nd if true")
          this.entityForm.controls['Entity_ID'].setValidators(Validators.nullValidator);
          this.entityForm.controls['Entity_ID'].disable();
          console.log("null vaidations");
          this.entityForm.controls['Entity_ID'].updateValueAndValidity();
        }
      }
      /*  if (selectedValue === "Tata Employee" && chkEvent) { */
      else {
        this.entityForm.controls['Entity_ID'].setValidators(Validators.nullValidator);
        // this.entityForm.controls['Entity_ID'].setValue("JL" + this.Entity_EMP_ID);
        // console.log("JL" + this.Entity_EMP_ID);

      }
    }
    else if(this.checkEvent === 'No') {
      this.existEntityFlag = false;
      this.entityForm.controls['Entity_ID'].setValidators(Validators.nullValidator);
      this.entityForm.controls['Entity_ID'].disable();
      this.entityForm.controls['Entity_ID'].updateValueAndValidity();
	  //Added 26/10
	    this.entityForm.controls['Organization_Type'].disable(); 
         this.entityForm.controls['Organization_Type'].setValidators(Validators.nullValidator);
          this.entityForm.controls['Organization_Type'].updateValueAndValidity();
	  //Added 16/9/2019
	  this.entityForm.controls['Pancard'].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)]); 
     //Added ends here
      console.log("null entity vaidations");
      this.Entity_ID_Existing = 'N';
	 // this.entityForm.reset();
    }
    else {


      this.entityForm.controls['Entity_ID'].setValidators(Validators.nullValidator);
      this.entityForm.controls['Entity_ID'].disable();
      console.log("null vaidations");
      this.entityForm.controls['Entity_ID'].updateValueAndValidity();
      // this.entityForm.controls['Organization'].setValidators(Validators.nullValidator);
      // this.entityForm.controls['Organization'].disable();
      // console.log("null vaidations");
      // this.entityForm.controls['Organization'].updateValueAndValidity();
    }
    this.entityForm.controls['Entity_ID'].updateValueAndValidity();
	  // this.entityForm.reset();
								//this.headerRegForm .clearValidators();
								//this.headerRegForm .updateValueAndValidity();
  }
  fileEvent(event): any {
    //*-- this function gets content of uploaded file and validation --

    var file = event.target.files[0];
    this.photoName = file.name;

    var allowedExtensions =
      ["jpg", "jpeg", "png", "JPG", "JPEG", "JFIF", "BMP", "SVG"];
    this.fileExtension = this.photoName.split('.').pop();

    if (this.isInArray(allowedExtensions, this.fileExtension)) {
      this.fileExtensionError = false;
      this.fileExtensionMessage = ""
	  alert("Invalid File 1 formate");
    } else {
      this.fileExtensionMessage = "Only photos allowed!!"
	  alert("Invalid File 2 formate");
      this.fileExtensionError = true;
    }

    if (file) {
      var reader = new FileReader();
      reader.onloadend = (e: any) => {
        var contents = e.target.result;
        this.photoContent = contents;
      }
      reader.readAsDataURL(file);
    } else {
      alert("Failed to load file");
    }
    console.log("this is file extension error", this.fileExtensionError)
  }

  /*- checks if word exists in array -*/
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  onSelectChildOrg(chkEvent, selectedValue) {
    console.log("inside onSelectChildOrg :");

    this.IsChild_Org = 'Y';
    this.entityForm.controls['child_OrgName'].reset();
    this.entityForm.controls['child_OrgName'].enable();
    console.log("IsChild_Org :", this.IsChild_Org);

    if (chkEvent) {
      this.entityForm.controls['child_OrgName'].reset();
      this.entityForm.controls['child_OrgName'].setValidators([Validators.required]);
    }
    else {
      this.entityForm.controls['child_OrgName'].disable();
      this.entityForm.controls['child_OrgName'].setValidators([Validators.nullValidator]);
      this.entityForm.controls['child_OrgName'].updateValueAndValidity();

    }
    this.entityForm.controls['child_OrgName'].updateValueAndValidity();
  }
  entityidAndPan(alreadyHaveEntity, alreadyHavePan) {
		console.log("alreadyHaveEntity ",alreadyHaveEntity,alreadyHavePan);
      this.valuechange(alreadyHaveEntity,alreadyHavePan)
    
  }
  
  onChangeFileUpload(event) {


 for(var i=0;i<event.target.files.length;i++)
 {
    this.myfiles.push(event.target.files[i])      
	
//	console.log("Sengathir"+this.myfiles[i].name);  
  
    this.uploadKYC = this.myfiles;
	//console.log("kathir"+this.uploadKYC);           
    var file = event.target.files[i];  
	console.log("file ----------- ",file);
    this.photoName = file.name;
	console.log("fileName=====>"+this.photoName);    
    console.log("the size is ", file.size) 
    if (file.size > 4242880) {
      console.log("The size is more ")
      this.fileSizeError1=true;
    }
    else{
      this.fileSizeError1=false;
    }
	if (file.size <= 0) {
      console.log("The size is less ")
      this.fileSizeError2=true;
    }
    else{
      this.fileSizeError2=false;
    }
    var allowedExtensions =
      ["jpg", "jpeg", "png", "JPG", "JPEG", "JFIF", "BMP", "SVG", "pdf","PNG"];
    this.fileExtension = this.photoName.split('.').pop();
     console.log("file__Namesssss"+this.fileExtension);     
    if (this.isInArray(allowedExtensions, this.fileExtension)) {
      this.fileExtensionError = false;
      this.fileExtensionMessage = ""
    } else {
      this.fileExtensionMessage = "Only photos allowed!!"
      this.fileExtensionError = true;
	  this.myfiles.push(event.target.files[i].name);
	  
    }

    if (file) {
      var reader = new FileReader();
      reader.onloadend = (e: any) => {
        var contents = e.target.result;
        this.photoContent = contents;
      }
      reader.readAsDataURL(file);
    } else {
      alert("Failed to load file");
    }
    console.log("this is file extension error", this.fileExtensionError);
  }

}

  onChangeRootVal() {
    this.rootVal = this.pePrefix + this.identifiedVal;
  }

  changeEntity(entity) {
    console.log("entity type :", entity);
    this.EntityType = entity;
  }
  changeEntityRole(entityRole) {
    console.log("entity role :", entityRole);
    this.EntityRole = entityRole;
  }
  changePEIdentity(peIdentity) {
    console.log("pe identity :", peIdentity);
    this.PEIdentity = peIdentity;
  }

  entityChange(entityIdcheck) {
    this.entityIdcheck = entityIdcheck.checked;
  }

  onSubmit() {
    console.log("Ent check", this.entCheck)
    if (this.entityForm.invalid) {
      console.log("invalid");
       this.disableForm=true;
      console.log("form 1 :", this.entityForm);
	  
	  let invalid = [];
	  let controls = this.entityForm.controls;
	  for ( const name in controls){
		  if(controls[name].invalid){
			  console.log("name __ ",name);
			  invalid.push(name);
		  }
		 // console.log("invalid ____________ ",invalid);
	  }
      return;
    }
    if (this.entCheck === 'No') {
      //verify
      this.Entity_ID_Existing = 'N';
      console.log("inside entCheck:....");
      console.log("this.IsChild_Org : ", this.IsChild_Org);
      this.Entity_ID = this.entityForm.get("Entity_ID").value;
      console.log("Entity_ID elsee:", this.Entity_ID);
      this.EntityRegistartion(this.Entity_ID_Existing, this.IsChild_Org);

      /*    this.ls.entityIdVerification(this.Entity_ID)
            .subscribe(r => {entity
    
              console.log("r query :", r);
              if (r == 'Y') {
                console.log("inn Y:");
                this.entityValidatedFlag = true;
                
                this.EntityRegistartion(this.Entity_ID_Existing, this.IsChild_Org);
              }
              else{
                console.log("no entityid in N");
                this.Entity_ID_Existing = 'N';
                this.entityValidatedFlag = false;
                this.$modal.successModal({
                  title: 'Error',
                  msg: 'Entity Id does not exist'
                });
                return;
              }
            }); */
      //verify ends here
    }

    else {
      this.onChangeRootVal();
      console.log("asdasd");
      this.Entity_ID_Existing = 'Y';
      console.log("@row#642")
      console.log("Entity id check is y now");
      console.log("data submitted");
      this.submitted = true;
      console.log("this.entityValidatedFlag ......", this.entityValidatedFlag);
      if (this.entityForm.invalid) {
        console.log("invalid");

        

        console.log("form 1 :", this.entityForm);
        return;
      }
      else {
        console.log("this.Entity_ID_Existing : ", this.Entity_ID_Existing)
        console.log("in else this.IsChild_Org : ", this.IsChild_Org)
        this.EntityRegistartion(this.Entity_ID_Existing, this.IsChild_Org);
      }

    }
    console.log("+++++++++++++++++The only one that matters++++++++++++++++++", this.Entity_ID_Existing)

    console.log("this.entCheck ------------------------ : ", this.entCheck);
  }

  onChangeRole(tataRole) {
    this.tataRole = tataRole.value;
  } 
  resetKYC(index) {
  //alert("HAI");  
  //this.myfiles.removeAt(index);          
  
  this.myfiles.splice(index,1)   
  this.entityForm.controls['uploadKYC1'].reset(index);  
   /* console.log(this.entityForm.controls['uploadKYC1'].value);          
    this.entityForm.controls['uploadKYC1']          
    console.log(this.entityForm.controls['uploadKYC1'].value);*/

  }

  EntityRegistartion(Entity_ID_Existing, IsChild_Org) {
    console.log("EntityRegistartion IsChild_Org ........:", IsChild_Org);
    if (IsChild_Org == 'Y') {
      this.Child_OrgName = this.entityForm.get("child_OrgName").value;
    }
    else {
      this.Child_OrgName = ""
    }
    let Entity_Role = this.EntityRole;
    let Entity_EMP_ID = this.entityForm.get("Entity_EMP_ID").value;
    console.log("Entity_ID_Existing ........:", Entity_ID_Existing);
    console.log("Entity_EMP_ID ........:", Entity_EMP_ID);

    let Entity_ContactName = this.entityForm.get("Entity_Name").value;
    let Entity_Mobile_No = this.entityForm.get("Entity_Mobile_No").value;
    let Entity_EmailID = this.entityForm.get("email").value;
    Entity_EmailID = Entity_EmailID.toLowerCase()
    console.log("email check", Entity_EmailID)
    let Entity_Addr = this.entityForm.get("Entity_Addr").value;
    // let Entity_User_Name = this.entityForm.get("Entity_User_Name").value;
    let Entity_Password = this.entityForm.get("Entity_Password").value;
    let Entity_ID = this.entityForm.get("Entity_ID").value;
    let Organization = this.entityForm.get("Organization").value;
    let Organization_Cat = this.entityForm.get("Organization_Type").value;
    let Organization_Type = this.entityForm.get("Organization_Cat").value;
    let poi = this.entityForm.get("Pancard").value;
    let poiType = this.entityForm.get("poiType").value;
    console.log("Child_OrgName :", this.Child_OrgName);
    const entityForm: FormData = new FormData();

    entityForm.append('Entity_EMP_ID', Entity_EMP_ID);
    //entityForm.append('Entity_Name', Organization);
    entityForm.append('Entity_ContactName', Entity_ContactName);
    entityForm.append('Entity_Mobile_No', Entity_Mobile_No);
    entityForm.append('Entity_EmailID', Entity_EmailID);
    entityForm.append('Entity_Addr', Entity_Addr);
	entityForm.append('Entity_Addr_DLT', this.Entity_Addr_DLT); 
    // entityForm.append('Entity_User_Name', Entity_User_Name);
    entityForm.append('Entity_Password', Entity_Password);
    // entityForm.append('E_TSP_Name', "TATA");
    // entityForm.append('Entity_ID_Existing', this.Entity_ID_Existing);
    entityForm.append('Entity_ID_Existing', Entity_ID_Existing);

   
    entityForm.append('E_Create_Date', currentdat);
    console.log("selected class value", this.selectedValue);
    if (this.selectedValue == "Tata Employee") {
      entityForm.append('E_Org_Name', 'TATA Tele');
      entityForm.append('Entity_ID', this.Entity_EMP_ID);
      entityForm.append('Entity_Class', "Tata Employee");
       entityForm.append('file1', "NA");
      // entityForm.append('file2', "NA");
      entityForm.append('Entity_Role', this.entityForm.get('Entity_Role').value);
      // console.log("tata role checking",this.tataRole);
      console.log("role chekcing", this.entityForm.get('Entity_Role').value);
      console.log("Tata Employee form : ", entityForm);
    }
    else if (this.selectedValue == "TM") {
      entityForm.append('E_Org_Name', Organization);
      console.log("entity id :", Entity_ID);
      entityForm.append('Entity_ID', Entity_ID);
      entityForm.append('Entity_Class', "TM");
      entityForm.append('Child_Org_Name', this.Child_OrgName);   
      entityForm.append('Child_Org_Flag', IsChild_Org);

      entityForm.append('E_Org_Type', Organization_Type);
      entityForm.append('E_Org_Cat', Organization_Cat);
      entityForm.append('E_Kyc_Doc_Type', poiType);
      entityForm.append('E_Kyc_Doc_No', this.entityForm.get("kycDocNo").value);
      const file1: any = document.getElementById('uploadKYC1');
      //const file2: any = document.getElementById('uploadAgreement');
	 //console.log("file1 __________________ :",file1);
	 console.log("file1sengathir __________________ :",this.myfiles);               
	 for(var i=0;i<=this.myfiles.length;i++)
	 {
		 console.log(this.myfiles[i]);   
		 entityForm.append('file'[i], this.myfiles[i]);		 
	 }
      	 
      //entityForm.append('Entity_Role', "NA");   
      //console.log("file :", file1.files[0]);
      //entityForm.append('file1', file1.files[0]);
	 // entityForm.append('file1', this.myfiles[0]);
      //entityForm.append('file2', this.myfiles[1]);
	  //entityForm.append('file3', this.myfiles[2]);
	  //entityForm.append('file4', this.myfiles[3]);
	  //entityForm.append('file5', this.myfiles[4]);
	  //entityForm.append('file6', this.myfiles[5]);
      entityForm.append('POI', poi);
    }

    else if (this.selectedValue == "PE") {
      entityForm.append('E_Org_Name', Organization);
      entityForm.append('Entity_ID', Entity_ID);
      entityForm.append('Entity_Class', "PE");
      entityForm.append('Child_Org_Name', this.Child_OrgName);
      entityForm.append('Child_Org_Flag', IsChild_Org);

      entityForm.append('E_Org_Type', Organization_Type);
      entityForm.append('E_Org_Cat', Organization_Cat);
      entityForm.append('E_Kyc_Doc_Type', poiType);
      //entityForm.append('E_Kyc_Doc_No', IsChild_Org);
	   entityForm.append('E_Kyc_Doc_No', this.entityForm.get("kycDocNo").value); 
      const file1: any = document.getElementById('uploadKYC1');
      // const file2: any = document.getElementById('uploadAgreement');
      // entityForm.append('Entity_Role', "NA");
      console.log("entityForm in PEEEEEEEEEE :", entityForm);
      //console.log("file :", file1.files[0]);
      //entityForm.append('file1', file1.files[0]);
	  for(var i=0;i<=this.myfiles.length;i++)
	 {
		 console.log(this.myfiles[i]);   
		 entityForm.append('file'[i], this.myfiles[i]);		 
	 }
      entityForm.append('POI', poi);
    }

    console.log("ENTITYTYTYTYTFORMMM : ", entityForm);
    this.es.entityRegistration(entityForm)
      .subscribe(r => {
        try {
          console.log("response _____ : ", r.validation_2);
          console.log("response _____ : ", r.validation_1);
          console.log("r.insertInMongo____ : ", r.insertInMongo);

          if (r.validation_2 == "Entity ID Already Exists in our System.Kindly use Existing Entity ID to proceed") {
            this.$modal.errorModal({
              title: 'Registration',
              msg: 'The PAN No you entered for ' + this.selectedValue + ' registration is already associated with some other entity, kindly use correct PAN details'
            });

          }
          if (r.validation_2 == "Entity registration under progress. Use another Entity ID") {
            this.$modal.errorModal({
              title: 'Registration',
             // msg: 'Email ID already exists!' 
              msg: 'The PAN No you entered for ' + this.selectedValue + ' registration is already associated with some other entity, kindly use correct PAN details'
            });
            console.log("r.validation_2   ", r.validation_2)
          }
          if (r.validation_1) {
            this.$modal.errorModal({
              title: 'Registration',
              msg: 'Email ID already exists!'
            });

          }
          if (r.validation_3) {
            this.$modal.errorModal({
              title: 'Registration',
              msg: 'Mobile number already exists!'
            });

          }
          // if (r.tataMongoInsert == true) {
          console.log("r.insertInMongo.Entity_Status ____ : ", r.insertInMongo.Entity_Status);
          if (r.insertInMongo.Entity_Status == "C") {
            //            console.log("try inside mongo",r);
            //          console.log("try insert data mongo",r.tataInsertData);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO, r.insertInMongo.Entity_Ref_No);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, r.insertInMongo.Entity_ID);


            this.$modal.successModal({
              title: 'Entity Registration',
              msg: 'Your request for new '+  this.selectedValue +' is registered with us and is pending for approval. We shall revert to you in 48 hours. ' + ' Your Id ' + r.insertInMongo.Entity_Ref_No
            });

            var data = {
              "EmailId": r.insertInMongo.EmailId,
              "Mobno": r.insertInMongo.Entity_Mobile_No,
              "notificationDate": currentdat,
              "contact_name": r.insertInMongo.Entity_Name,
              "entity_ref_number": r.insertInMongo.Entity_Ref_No,
              "entity_username": r.insertInMongo.EmailId,
              "notificationType": "EntityRegistration"

            }
            // this.es.entityRegistrationNotification(data)
            //   .subscribe(r => {
            //     this.$modal.successModal({
            //       title: 'Registration',
            //       msg: 'Notification has been sent!'
            //     });
            //   })
            this.router.navigate(['/']);
          }
          //      console.log("response chekcing : ",JSON.stringify(r));
          //   console.log("dlt response",r.DLTResponse);
          if (r.DLTResponse.status == true) {
            //   console.log("try inside");
            if (r.DLTResponse.status == true) {
              this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO, r.docupload.Entity_Ref_No);
              this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, r.docupload.Entity_ID);

              this.$modal.successModal({
                title: 'Entity Registration',
                msg: 'Your request for new '+  this.selectedValue +' is registered with us and is pending for approval. We shall revert to you in 48 hours. ' + ' Your Id ' + r.insertInMongo.Entity_Ref_No
              });
              var data = {
                "EmailId": r.insertInMongo.EmailId,
                "Mobno": r.insertInMongo.Entity_Mobile_No,
                "notificationDate": currentdat,
                "contact_name": r.insertInMongo.Entity_Name,
                "entity_ref_number": r.insertInMongo.Entity_Ref_No,
                "entity_username": r.insertInMongo.EmailId,
                "notificationType": "EntityRegistration"

              }
              // this.es.entityRegistrationNotification(data)
              //   .subscribe(r => {
              //     this.$modal.successModal({
              //       title: 'Registration',
              //       msg: 'Notification has been sent!'
              //     });
              //   })
            }
          }
        }

        catch (e) {
          //          console.log("within catch ",e);
          if (r.usernamecheck === "Username already exists") { 
            //this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO, r.docupload.Entity_Ref_No);
            this.$modal.errorModal({
              title: 'Error',
              msg: 'Email ID Already Exists!'
            });

          }
        }


      });

  }  
  //val="";  
//public TanNo=false;     
//public PanNo=true;  
//public GstNo=false;
//public CRNno=false; 
 public validKyc;
 public errmsg;

/*kycdocty(ev)                  
{     
 // alert(ev.target.value);                      

if(ev.target.value == "TAN") 
{
	
    //this.TanNo=true;
    //this.PanNo=false;
    //this.GstNo=false;
    //this.CRNno=false;
     //this.entityForm.controls['kycDocNo'].reset();     
	 //this.entityForm.controls['kycDocNo'].reset();   
	 //kycDocNo 
this.entityForm.controls['kycDocNo'].reset();
this.entityForm.controls['kycDocNo'].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z]){4}([0-9]{5})([a-zA-Z]){1}?$/)]);  
this.errmsg="Tan Number is Required";	
this.validKyc="Please Enter Valid Tan Number ";   
}
if(ev.target.value == "PAN")          
{
	
    //this.PanNo=true;
   //this.TanNo=false;
   //this.GstNo=false; 
   //this.CRNno=false;   
   //this.entityForm.controls['Pancard'].reset();
}
if(ev.target.value == "GST")            
{
   //this.PanNo=false;
   //this.TanNo=false;
   //this.GstNo=true;
    //this.CRNno=false;	
	this.entityForm.controls['kycDocNo'].reset();     
    //this.entityForm.controls['Pancard'].setValidators([Validators.required, Validators.pattern()   
//^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$)] 
//  	
this.entityForm.controls['kycDocNo'].setValidators([Validators.required, Validators.pattern(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}Z[0-9]{1}?$/)]);
this.errmsg="GST Number is Required";	
this.validKyc="Please Enter Valid GST Number ";	    
 	
}
if(ev.target.value == "CRN") 
{
	//this.PanNo=false;
   //this.TanNo=false;
   // this.GstNo=false; 
    //this.CRNno=true;	 
	this.entityForm.controls['kycDocNo'].reset();      
	this.entityForm.controls['kycDocNo'].setValidators([Validators.required, Validators.pattern(/^[A-Z]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}?$/)]);
	this.errmsg="CRN Number is Required";	
this.validKyc="Please Enter Valid CRN Number ";
	
}
if(ev.target.value == "other"){
	this.entityForm.controls['kycDocNo'].reset();           
    //this.entityForm.controls['kycDocNo'].setValidators([Validators.required, Validators.pattern(/^[A-Za-z]?$/)]);            	    
	this.errmsg="KYC Document Number is Required";                 
} 
	
  } 
  /* this.entityForm.controls['poiType'].valueChanges.subscribe(val =>    
   {
   alert(val);       
   }   
   
   ); */
  
}   
export function noWhiteSpace(control: AbstractControl) {   
//alert("hai");
var data= control.value;

  if (data == " " || data.charAt(0) === " " || data.charAt(data.length-1) === " ") {  

    return { validUrl: true };

  }

  return null;

}
